import { render, staticRenderFns } from "./TagPicker.vue?vue&type=template&id=4eb56f72&"
import script from "./TagPicker.vue?vue&type=script&lang=js&"
export * from "./TagPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports